import { ErrorSpan } from "@/components/ErrorSpan";
import { hasBom } from "@/utils/sos/utilities";
import { Item } from "../queries/tracking-data/items";
import { formatPurchaseTaxCode } from "./bom-by-component/TaxCodeCell";

/**
 * Renders the preferred vendor for an item along with the vendor's tax code (and any errors related to the vendor's tax code).
 */
export const PreferredVendorCell: React.FC<{ item: Item; showTax?: boolean }> = ({ item, showTax = true }) => {
  const vendor = item.preferredVendor;
  const missingVendor = !hasBom(item.type) && !vendor;
  const missingTaxCode = showTax && vendor && !vendor.taxCode;
  const error =
    missingVendor ? "no preferred vendor selected"
    : missingTaxCode ? "tax code is missing"
    : null;

  const taxCodeSuffix = showTax && vendor?.taxCode ? ` (${formatPurchaseTaxCode(vendor.taxCode)})` : "";
  const vendorText = vendor ? `${vendor.name}${taxCodeSuffix}` : null;

  return (
    <>
      {vendorText} {error && <ErrorSpan>⚠ {error}</ErrorSpan>}
    </>
  );
};
